import { Component, Host, Prop, h } from '@stencil/core';

@Component({
  tag: 'cradlepoint-hero',
  styleUrl: 'cradlepoint-hero.css',
  shadow: true,
})
export class CradlepointHero {
  @Prop() backgroundImage     : string;
  @Prop() backgroundPosition  : string = 'right';
  @Prop() backgroundSize      : string = 'cover';
  @Prop() gradientStartColor  : string = 'rgba(0, 0, 0, 0.65)';
  @Prop() gradientMiddleColor : string = 'rgba(0, 0, 0, 0.32)';
  @Prop() gradientEndColor    : string = 'rgba(0, 0, 0, 0)';
  @Prop() contentWidth        : string = '1024px';
  @Prop() contentAlign        : string = 'left';
  @Prop() minHeight           : string = '600px';

  render() {
    let gradientBg = `linear-gradient(${this.contentAlign == 'right' ? '270deg' : '90deg' }, ${this.gradientStartColor} 0%, ${this.gradientMiddleColor} 50%, ${this.gradientEndColor} 100%)`;
    if (this.contentAlign == 'center') {
      gradientBg = `linear-gradient(90deg, ${this.gradientEndColor} 0%, ${this.gradientMiddleColor} 25%, ${this.gradientStartColor} 50%, ${this.gradientMiddleColor} 75%, ${this.gradientEndColor} 100%)`;
    }

    return (
      <Host
        style={{
          backgroundImage: `url(${this.backgroundImage})`,
          backgroundPosition: this.backgroundPosition,
          backgroundSize: this.backgroundSize,
          minHeight: this.minHeight
        }}
      >
        <div class="tint"
          style={{
            background: gradientBg,
          }}
        >
          <div class={`content-container ${this.contentAlign}`}
            style={{
              maxWidth: this.contentWidth,
              textAlign: this.contentAlign
            }}
          >
            <slot></slot>
          </div>
        </div>
      </Host>
    );
  }

}
